import React from 'react';
import css from './CardSpinner.module.css';

function CardSpinner() {
  return <span className={css.loader}></span>;
}

export default CardSpinner;
